import { render } from "./ErrorPagesHome.vue?vue&type=template&id=681b2432"
import script from "./ErrorPagesHome.vue?vue&type=script&lang=js"
export * from "./ErrorPagesHome.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__